(self.webpackChunkjuno_shopify_template=self.webpackChunkjuno_shopify_template||[]).push([[211], {
  4211: function(t, e, a) {
    a.r(e),
    a.d(e, { VariantOptions: function() { return n } });
    
    var i = a(4412);
    
    class n extends HTMLElement {
      constructor() {
        super();
        this.currentVariant = void 0;
        this.addEventListener("change", this.onVariantChange);
      }
      
      onVariantChange(t) {
        this.updateOptions();
        this.updateMasterId();
        this.updateSelectedValue(t.target);
        this.toggleAddButton(!0, "");
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.currentVariant ? (this.updateURL(), this.updateVariantInput(), this.renderProductInfo()) : (this.toggleAddButton(!0, ""), this.setUnavailable());
      }
      
      updateOptions() {
        const t = Array.from(this.querySelectorAll("fieldset"));
        this.options = t.map((t => Array.from(t.querySelectorAll("input")).find((t => t.checked)).value));
      }
      
      updateMasterId() {
        this.currentVariant = this.getVariantData().find((t => !t.options.map(((t, e) => this.options[e] === t)).includes(!1)));
      }
      
      updateSelectedValue(t) {
        const e = (0, i.U2)(`[data-selected-option=${t.name}]`, this);
        e && (e.textContent = t.value);
      }
      
      updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
      }
      
      updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}`).forEach((t => {
          const e = t.querySelector('input[name="id"]');
          e.value = this.currentVariant.id;
          e.dispatchEvent(new Event("change", { bubbles: !0 }));
        }));
      }
      
      updateVariantStatuses() {
        const t = this.variantData.filter((t => this.querySelector(":checked").value === t.option1)),
              e = [...this.querySelectorAll("fieldset")];
        e.forEach(((a, i) => {
          if (0 === i) return;
          const n = [...a.querySelectorAll('input[type="radio"], option')],
                s = e[i - 1].querySelector(":checked").value,
                r = t.filter((t => t.available && t[`option${i}`] === s)).map((t => t[`option${i + 1}`]));
          this.setInputAvailability(n, r);
        }));
      }
      
      setInputAvailability(t, e) {
        t.forEach((t => {
          e.includes(t.getAttribute("value")) ? t.classList.remove("disabled") : t.classList.add("disabled");
        }));
      }
      
      removeErrorMessage() {
        const t = this.closest("section");
        if (!t) return;
        const e = t.querySelector("[is=product-form]");
        /*e&&e.handleErrorMessage()*/
      }
      
      renderProductInfo() {
        const t = this.currentVariant.id;
        fetch(`${this.dataset.url}?variant=${t}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`).then((t => t.text())).then((e => {
          if (this.currentVariant.id !== t) return;
          const a = (new DOMParser).parseFromString(e, "text/html");
          {
            const t = document.getElementById(`price-${this.dataset.section}`),
                  e = a.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            e && t && (t.innerHTML = e.innerHTML);
            const i = document.getElementById(`price-${this.dataset.section}`);
            i && i.classList.remove("visibility-hidden");
          }
          this.toggleAddButton(!this.currentVariant.available, Shopify.theme.i18n.soldOut);
        }));
      }
      
      toggleAddButton(t = !0, e) {
        const a = document.getElementById(`product-form-${this.dataset.section}`);
        if (!a) return;
        const i = a.querySelector('[name="add"]');
        if (!i) return;
        const n = a.querySelector('[name="add"] > span');
        t ? (i.setAttribute("disabled", "disabled"), e && (n.textContent = e)) : (i.removeAttribute("disabled"), n.textContent = Shopify.theme.i18n.addToCart);
      }
      
      setUnavailable() {
        const t = document.getElementById(`product-form-${this.dataset.section}`),
              e = t.querySelector('[name="add"]'),
              a = t.querySelector('[name="add"] > span'),
              i = document.getElementById(`price-${this.dataset.section}`),
              n = document.getElementById(`Inventory-${this.dataset.section}`),
              s = document.getElementById(`Sku-${this.dataset.section}`);
        e && (a.textContent = window.variantStrings.unavailable, i && i.classList.add("visibility-hidden"), n && n.classList.add("visibility-hidden"), s && s.classList.add("visibility-hidden"));
      }
      
      getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData;
      }
    }
    
    customElements.define("variant-options", n);
  }
}]);
